import script from "./TransferPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransferPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./TransferPopUp.vue?vue&type=style&index=0&id=de1493e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de1493e2"]])

export default __exports__